export default __webpack_public_path__ + "static/media/circle1.a5bbc0ad.jpg";